import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

type chatData = {
    comentario: string;
    file?: File;
    id_planejamento: string;
}

const create = async (data: any): Promise<any> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./comentario', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar menssagem.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao criar menssagem.');
    }
};

const list = async (uuid:string): Promise<any> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./comentarios?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const delet = async(uuid: string): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete('./comentario', {
            headers: {
                Authorization: `${token}`
            },
            params: {
                'uuid': uuid
            }
        });

        if(response.data){
            return response.data; 
        }

        return new Error('Falha ao deletar registro');
    } catch (error) {
        Error((error as { message: string}).message || 'Erro ao deletar registro');
    }
};


export const ChatServices= {
    create,
    list,
    delet
};